import { WebComponent } from '@helpers/WebComponent';
import { createWebComponentInstances, dispatchCustomEvent } from '@helpers/functions';
import { globalCpmCloseLocaleSelectorEvent, globalCpmWebComponentName } from '../../web-components/globalCpm/_data';

const classNamePrefix = 'arjo-o-locale-selector';

class LocaleSelector extends WebComponent {
  localeSelector: Element | null = null;

  constructor(rootNode: Document | ShadowRoot) {
    super(rootNode);
  }

  initPrepare() {
    this.localeSelector = this.rootNode.querySelector(`.${classNamePrefix}`);
    this.addEventIntoCloseButton();
    this.addEventIntoToggles();
    this.addEventIntoLinks();
    this.listenGlobalCpmCloseEvent();
  }

  listenGlobalCpmCloseEvent() {
    window.addEventListener(globalCpmCloseLocaleSelectorEvent, () => {
      this.closeLocaleSelector();
    });
  }

  closeLocaleSelector() {
    if (!this.localeSelector) return;

    this.localeSelector.classList.remove('active');
    this.localeSelector.querySelector?.('style')?.setAttribute('media', 'not all');
  }

  addEventIntoCloseButton() {
    const closeButton = this.localeSelector?.querySelector(`.${classNamePrefix}__close-button`);

    if (!closeButton) return;
    // While we need to re init this script base on external web component data, we need remove previous event listener on the element
    closeButton.removeEventListener('click', () => this.closeLocaleSelector());

    closeButton.addEventListener('click', () => this.closeLocaleSelector());
  }

  openLocaleSelector() {
    if (!this.localeSelector) return;

    this.localeSelector.classList.add('active');
    this.localeSelector.querySelector?.('style')?.removeAttribute('media');
  }

  addEventIntoToggles() {
    const toggles = [...this.rootNode.querySelectorAll('[data-locale-selector-toggle]')];

    toggles.forEach((t) => {
      // While we need to re init this script base on external web component data, we need remove previous event listener on the element
      t.removeEventListener('click', () => this.openLocaleSelector());

      t.addEventListener('click', () => this.openLocaleSelector());
    });
  }

  linkClickHandler(event: Event) {
    event.preventDefault();

    const target = event.currentTarget as HTMLAnchorElement;

    if (!target) return;

    const apiUrl = target.dataset.apiUrl || '';
    const href = target.getAttribute('href') || '';
    const eventData = target.getAttribute('data-event-data');

    if (eventData) {
      dispatchCustomEvent({
        eventName: 'cpm-switch-lang',
        eventDict: {
          detail: {
            data: eventData,
          },
        },
      });

      return;
    }

    try {
      fetch(apiUrl).then(() => {
        window.location.assign(href);
      });
    } catch (error) {
      console.log(error);
    }
  }

  addEventIntoLinks() {
    if (!this.localeSelector) return;

    const links = [...this.localeSelector.querySelectorAll(`.${classNamePrefix}__linkgroup-item a`)];

    links.forEach((l) => {
      // While we need to re init this script base on external web component data, we need remove previous event listener on the element
      l.removeEventListener('click', this.linkClickHandler);

      l.addEventListener('click', this.linkClickHandler);
    });
  }
}

const localSelectors = createWebComponentInstances<LocaleSelector>(LocaleSelector, globalCpmWebComponentName);

// Web component only cannot access into class instance without window object
window.localSelectors = localSelectors;

window.addEventListener('DOMContentLoaded', () => {
  localSelectors.forEach((localeSelector) => {
    if (localeSelector.rootNode instanceof Document) {
      localeSelector.initPrepare();
    }
  });
});

export { LocaleSelector };
